import { Action } from 'redux';

import {
  GETTING_UPLOADS,
  IGotUploadsAction,
  GOT_UPLOADS,
  UploadsActionTypes,
  CANCELLED_UPLOAD,
  IUploadAction,
  CANCELLING_UPLOAD,
  REMOVING_UPLOAD,
  REMOVED_UPLOAD,
} from '@store/types';

import {
  uploads as uploadsRequest,
  cancel as cancelRequest,
  remove as removeRequest,
} from '@services/upload';
import { IUpload } from '@models';
import { addNotification } from '@store/actions';
import i18n from '@configs/i18n';

export const gotUploads = (uploads: IUpload[]): IGotUploadsAction => ({
  type: GOT_UPLOADS,
  payload: uploads,
});

export const gettingUploads = (): Action => ({
  type: GETTING_UPLOADS,
});

export const getUploads = (): any => {
  return (dispatch: (action: UploadsActionTypes) => void) => {
    dispatch(gettingUploads());
    uploadsRequest()
      .then((uploads: IUpload[]) => {
        return dispatch(gotUploads(uploads));
      })
      .catch((e) => {
        console.error(e);
      });
  };
};

export const uploadCancelled = (upload: IUpload): IUploadAction => ({
  type: CANCELLED_UPLOAD,
  payload: upload,
});

export const cancellingUpload = (upload: IUpload): IUploadAction => ({
  type: CANCELLING_UPLOAD,
  payload: upload,
});

export const cancelUpload = (upload: IUpload): any => {
  return (dispatch: (action: UploadsActionTypes) => void) => {
    dispatch(cancellingUpload(upload));
    cancelRequest(upload.id)
      .then((response: void) => {
        dispatch(uploadCancelled(upload));
      })
      .catch(() => {
        dispatch(
          addNotification({
            title: i18n.t('notification_cancelUploadFailed_title'),
            body: i18n.t('notification_cancelUploadFailed_body'),
          })
        );
        dispatch(getUploads());
      });
  };
};

export const removeUpload = (upload: IUpload): any => {
  return (dispatch: (action: UploadsActionTypes) => void) => {
    dispatch({
      type: REMOVING_UPLOAD,
      payload: upload,
    });
    removeRequest(upload.id)
      .then(() => {
        dispatch({
          type: REMOVED_UPLOAD,
          payload: upload,
        });
      })
      .catch(() => {
        dispatch(getUploads());
      });
  };
};
